import React from 'react'
import { useInView } from 'react-intersection-observer'
import classNames from 'classnames'
import './AnimatedSymbol.scss'

type Props = {
  symbol: React.FC<{ className?: string; style?: React.CSSProperties }>
  symbolStyle?: React.CSSProperties
}
export default function AnimatedSymbol({
  symbol: Component,
  symbolStyle,
}: Props) {
  const [inViewRef, inView] = useInView({ triggerOnce: true, threshold: 1 })

  return (
    <div
      ref={inViewRef}
      className={classNames('scale-90 transform lg:scale-100')}
    >
      <div
        className={classNames(
          'c-blog-symbol text-green',
          inView && 'c-blog-symbol--in-view',
        )}
      >
        <span className="c-blog-symbol__circle c-blog-symbol__circle--lg" />
        <span className="c-blog-symbol__circle c-blog-symbol__circle--md" />
        <span className="c-blog-symbol__circle c-blog-symbol__circle--sm" />
        <Component
          className="c-blog-symbol__symbol"
          style={symbolStyle || {}}
        />
      </div>
    </div>
  )
}
